module.exports = __webpack_public_path__ + "img/fan-table.00c5bec6.svg";